import React, { FunctionComponent, useState } from "react";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  TextField,
  useMediaQuery
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useStyles from "./style";
import { SegmentRule, RuleParameter } from "../../../models/Segment";
import { AddCircle, PlaylistAddCheck } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import { add, update, uploadUsers } from "../../../api/segmentApi";
import Alert from "@material-ui/lab/Alert";
import { isOk } from "../../../result";

export interface SaveSegmentDialogProps {
  open: boolean;
  segmentId?: string;
  segmentName: string;
  rules?: SegmentRule[];
  file?: Blob;
  onSave: () => void;
  onCancel: () => void;
}

export const SaveSegmentDialog: FunctionComponent<SaveSegmentDialogProps> = ({
  open,
  segmentId,
  segmentName,
  rules,
  file,
  onSave,
  onCancel
}) => {
  const classes = useStyles();

  const [name, setName] = useState(segmentName);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);

  return (
    <Dialog open={open}>
      <DialogTitle>Enter a name for your segment</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This is how you identify your segment when creating campaigns and
          communications.
        </DialogContentText>
        <TextField
          style={{ flex: 1 }}
          className={classes.field}
          label="Name"
          value={name ?? ""}
          onChange={e => {
            setName(e.target.value);
          }}
        />
        {loading && <LinearProgress />}
      </DialogContent>
      <DialogActions>
        <Button color={"primary"} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          color={"primary"}
          disabled={loading || !name}
          onClick={async () => {
            setLoading(true);
            const result = segmentId
              ? await update(segmentId, name, rules ? rules : [])
              : await add(name, rules ? rules : []);

            if (isOk(result) && file) {
              await uploadUsers(segmentId ? segmentId : result.value, file);
            }

            setLoading(false);
            setShowError(result.type !== "OK");

            if (result.type === "OK") {
              onSave();
            }
          }}
        >
          Save
        </Button>
        {showError && (
          <Alert severity="error">
            An error occured when adding or updating segment
          </Alert>
        )}
      </DialogActions>
    </Dialog>
  );
};
